/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxLightningBIcon16Light } from './NatureFxLightningBIcon16Light';
import { NatureFxLightningBIcon16Regular } from './NatureFxLightningBIcon16Regular';
import { NatureFxLightningBIcon16Solid } from './NatureFxLightningBIcon16Solid';
import { NatureFxLightningBIcon20Light } from './NatureFxLightningBIcon20Light';
import { NatureFxLightningBIcon20Regular } from './NatureFxLightningBIcon20Regular';
import { NatureFxLightningBIcon20Solid } from './NatureFxLightningBIcon20Solid';
import { NatureFxLightningBIcon24Regular } from './NatureFxLightningBIcon24Regular';
import { NatureFxLightningBIcon24Solid } from './NatureFxLightningBIcon24Solid';
import { NatureFxLightningBIcon32Regular } from './NatureFxLightningBIcon32Regular';
import { NatureFxLightningBIcon64Regular } from './NatureFxLightningBIcon64Regular';
var sizes = {
    16: {
        light: NatureFxLightningBIcon16Light,
        regular: NatureFxLightningBIcon16Regular,
        solid: NatureFxLightningBIcon16Solid,
    },
    20: {
        light: NatureFxLightningBIcon20Light,
        regular: NatureFxLightningBIcon20Regular,
        solid: NatureFxLightningBIcon20Solid,
    },
    24: {
        regular: NatureFxLightningBIcon24Regular,
        solid: NatureFxLightningBIcon24Solid,
    },
    32: {
        regular: NatureFxLightningBIcon32Regular,
    },
    64: {
        regular: NatureFxLightningBIcon64Regular,
    },
};
export var NatureFxLightningBIcon = forwardRef('NatureFxLightningBIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
